import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b93bf1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-footer-container" }
const _hoisted_2 = { class: "btns-payment" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["PaymentInfoSection"], {
        shouldPay: $setup.shouldPay,
        seatsSelectable: $props.seatsSelectable,
        bookingDates: $props.bookingDates,
        totalAmount: $props.totalAmount,
        oneTimeFare: $props.oneTimeFare,
        currentBookInterval: $props.currentBookInterval
      }, null, 8 /* PROPS */, ["shouldPay", "seatsSelectable", "bookingDates", "totalAmount", "oneTimeFare", "currentBookInterval"]),
      _createElementVNode("footer", null, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paymentMethods, (paymentMethod) => {
            return (_openBlock(), _createBlock($setup["BaseButton"], {
              key: paymentMethod.code,
              class: "btn-payment",
              title: paymentMethod.displayText,
              disabled: !$setup.isBookableState() || $setup.isBookBlocked,
              onOnClick: ($event: any) => ($setup.onClickPaymentButton(paymentMethod.pgCode))
            }, null, 8 /* PROPS */, ["title", "disabled", "onOnClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    _createVNode($setup["BookKcp"], {
      ref: "bookKcpRef",
      onOnBookComplete: $setup.onCompletedKcpBook,
      onOnClickCloseKcp: _cache[0] || (_cache[0] = ($event: any) => ($setup.bookInProgress = false))
    }, null, 512 /* NEED_PATCH */),
    ($setup.shouldShowPaymentTimeoutModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "결제하기",
          okButtonTitle: "확인",
          cancelButtonTitle: "취소",
          onOnClickOkButton: _cache[1] || (_cache[1] = ($event: any) => ([$setup.processPayment(), $setup.toggleShowPaymentTimeoutModal(false)])),
          onOnClickCancelButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowPaymentTimeoutModal(false)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_3, [
              _createTextVNode(" 총 결제금액 " + _toDisplayString($setup.useCurrencyFormat($props.totalAmount)) + "원을 결제하시겠습니까?", 1 /* TEXT */),
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString($setup.paymentTimeoutMin.toString()) + "분 이내 결제하지 않을 경우 만료처리 됩니다. ", 1 /* TEXT */)
            ])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}